<div class="ub ub-ver fw">
  <a-tabs v-model:activeKey="activeKey" :tab-position="mode" @change="changeTab">
    <a-tab-pane
      :key="item.code"
      :tab="item.name + '(' + item.total + ')'"
      v-for="(item, index) in tabsArr"
    >
    </a-tab-pane>
    <template #rightExtra>
      <slot name="rightButton">
        <a-button type="primary" @click="onChangeBtn">
          {{showBtn?'切换为仓库视角':'切换为项目视角'}}
        </a-button>
      </slot>
    </template>
  </a-tabs>
</div>